import { CommunicationAlert, CommunicationAlertsResponseBody, CommunicationCategory } from '../entities';
import { CommunicationTask } from '../entities/CommunicationAlert';

const CommunicationAlertsDataResponseDTOtoCommunicationAlertsDataAdapter = (
  response: CommunicationAlertsResponseBody,
): CommunicationAlert[] => {
  const alertList: CommunicationAlert[] = response.headers.reduce((accHeaders, header) => {
    const categoriesList = header.categories.reduce((acc, category) => {
      const list = category.tasks.map(task => ({
        id: task.id,
        name: task.description,
        rules: {
          email: Boolean(task.enableEmail),
          sms: Boolean(task.enableSms),
          notification: Boolean(task.enablePush),
        },
      })) as CommunicationTask[];
      acc.push({
        id: category.id,
        name: category.value,
        list,
        rules: { email: category.enableEmail, sms: category.enableSms, notification: category.enablePush },
      });
      return acc;
    }, [] as CommunicationCategory[]);

    accHeaders.push({ id: header.id, name: header.description, categories: categoriesList });
    return accHeaders;
  }, [] as CommunicationAlert[]);

  return alertList.map(alert => new CommunicationAlert(alert.id, alert.name, alert.categories));
};

export { CommunicationAlertsDataResponseDTOtoCommunicationAlertsDataAdapter };
